import { render } from "./Redes.vue?vue&type=template&id=63ea23f2"
import script from "./Redes.vue?vue&type=script&lang=js"
export * from "./Redes.vue?vue&type=script&lang=js"

import "./Redes.vue?vue&type=style&index=0&id=63ea23f2&lang=scss"

import exportComponent from "/Users/nicorivera/Documents/NR/Sate/sate2023/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__